export default {
  hash: null,
  cards: null,
  rotation: null,
  loading: false
};
